export default __webpack_public_path__ + "static/giant-1-7a9aa61a4d991b2b7ab93595dcd970ec.jpg";